import { render, staticRenderFns } from "./ObiDropdownDivider.vue?vue&type=template&id=02f36048&scoped=true&"
import script from "./ObiDropdownDivider.vue?vue&type=script&lang=js&"
export * from "./ObiDropdownDivider.vue?vue&type=script&lang=js&"
import style0 from "./ObiDropdownDivider.vue?vue&type=style&index=0&id=02f36048&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f36048",
  null
  
)

export default component.exports